// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3bNxx","vLegacy":"SelectSecondary_vLegacy__4UaBa","error":"SelectSecondary_error__2Ny6J","disabled":"SelectSecondary_disabled__ilamg"};